<template>
  <div class="radio-field-response">
    <div class="field-header">
      <h3 class="field-label">
        {{ field.label }}
        <span v-if="field.required" class="required-indicator">*</span>
        <v-chip x-small color="warning" class="ml-2" v-if="field.useAggregate">Auto-calculated</v-chip>
      </h3>
    </div>

    <div v-if="field.description" class="field-description">
      {{ field.description }}
    </div>

    <v-radio-group
      v-model="selectedOptionId"
      :readonly="disabled || isAggregateField"
      :disabled="isAggregateField"
      :rules="isAggregateField ? [] : getValidationRules()"
      @change="updateSelection"
    >
      <v-radio
        v-for="option in fieldOptions"
        :key="option.id"
        :value="option.id"
        :label="option.label"
        color="primary"
      ></v-radio>
    </v-radio-group>

    <v-textarea
      v-model="localResponse.comment"
      :readonly="disabled"
      outlined
      dense
      label="Comment (Optional)"
      placeholder="Add any additional comments here..."
      rows="2"
      auto-grow
      @change="updateResponse"
    ></v-textarea>
  </div>
</template>

<script>
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Field } from '@/shared/types/aperTemplate';
import { ResponseDTO } from '@/shared/apis/aper/aperEvaluations';

@Component
export default class RadioFieldResponse extends Vue {
  @Prop({ type: Object, required: true }) field;
  @Prop({ type: Object, required: false }) response;
  @Prop({ type: Boolean, required: false }) disabled;

  localResponse = {
    fieldId: 0,
    selectedOptionIds: [],
    comment: ''
  };

  selectedOptionId = null;

  created() {
    this.initializeResponse();
  }

  @Watch('response')
  onResponseChange() {
    this.initializeResponse();
  }

  initializeResponse() {
    if (this.response) {
      this.localResponse = { ...this.response };

      // Initialize the selected radio option based on response
      this.selectedOptionId = this.response.selectedOptionIds && this.response.selectedOptionIds.length > 0
        ? this.response.selectedOptionIds[0]
        : null;
    } else {
      this.localResponse = {
        fieldId: this.field.id || 0,
        selectedOptionIds: [],
        comment: ''
      };

      this.selectedOptionId = null;
    }
  }

  get fieldOptions() {
    return [...(this.field.options || [])].sort(
      (a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)
    );
  }

  get isAggregateField() {
    return this.field.useAggregate === true;
  }

  getValidationRules() {
    const rules = [];

    if (this.field.required) {
      rules.push((v) => v !== null || `${this.field.label} is required`);
    }

    return rules;
  }

  updateSelection() {
    this.localResponse.selectedOptionIds = this.selectedOptionId !== null
      ? [this.selectedOptionId]
      : [];

    this.updateResponse();
  }

  updateResponse() {
    this.$emit('update:response', this.localResponse);
  }
}
</script>

<style scoped>
.radio-field-response {
  width: 100%;
}

.field-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.field-label {
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  margin: 0 0 4px 0;
}

.required-indicator {
  color: #f44336;
  margin-left: 4px;
}

.field-description {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 12px;
}
</style>
